/**
 * Download blob response from export-rpu / export-excel APIs.
 */
export function downloadBlobResponse(response, fallbackName = "Form24Q_RPU.zip") {
  const disposition = response?.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="?([^";\n]+)"?/i);
  const filename = match?.[1] || fallbackName;
  const contentType =
    response?.headers?.["content-type"] ||
    (String(fallbackName).toLowerCase().endsWith(".xlsx")
      ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      : "application/zip");
  const blob = new Blob([response.data], { type: contentType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
  return filename;
}

async function parseBlobError(err, fallbackMessage) {
  if (err?.response?.data instanceof Blob) {
    const text = await err.response.data.text();
    let json = null;
    try {
      json = JSON.parse(text);
    } catch {
      throw new Error(text || fallbackMessage);
    }
    const validationErrors = json?.data?.validation?.errors || [];
    const detail = validationErrors
      .map((e) => e.message)
      .filter(Boolean)
      .slice(0, 3)
      .join("; ");
    const base = json.message || fallbackMessage;
    throw new Error(detail && !String(base).includes(detail) ? `${base}: ${detail}` : base);
  }
  throw err;
}

export async function exportAndDownloadRpu(payrollOpsService, params) {
  try {
    const response = await payrollOpsService.exportForm24QRpu(params);
    return downloadBlobResponse(response);
  } catch (err) {
    return parseBlobError(err, "RPU export failed");
  }
}

export async function exportAndDownloadForm138Excel(payrollOpsService, params) {
  try {
    const response = await payrollOpsService.exportForm138Excel(params);
    return downloadBlobResponse(response, "Form138.xlsx");
  } catch (err) {
    return parseBlobError(err, "Form 138 Excel export failed");
  }
}
